(() => {
  const start = () => {
    const target = document.querySelector('script[data-ap-product-schema]');
    const widget = document.querySelector('[data-ap-reviews-section] etrusted-widget[data-sku]');
    if (!target || !widget || target.dataset.apReviewBound) return;
    target.dataset.apReviewBound = 'true';
    const skus = new Set(widget.getAttribute('data-sku').split(',').map(sku => sku.trim()).filter(Boolean));
    const parse = script => {
      try { return JSON.parse(script.textContent); } catch { return null; }
    };
    const merge = () => {
      const product = parse(target);
      if (!product || product['@type'] !== 'Product') return;
      for (const source of document.head.querySelectorAll('script[type="application/ld+json"]')) {
        if (source === target) continue;
        const reviewProduct = parse(source);
        if (!reviewProduct || reviewProduct['@type'] !== 'Product' || !skus.has(String(reviewProduct.sku))) continue;
        const rating = reviewProduct.aggregateRating;
        const value = Number(rating?.ratingValue);
        const count = Number(rating?.ratingCount ?? rating?.reviewCount);
        if (!rating || !Number.isFinite(value) || value < 1 || value > 5 || !Number.isInteger(count) || count < 1) continue;
        product.aggregateRating = rating;
        if (Array.isArray(reviewProduct.review) && reviewProduct.review.length) product.review = reviewProduct.review;
        target.textContent = JSON.stringify(product).replace(/</g, '\\u003c');
        source.remove();
      }
    };
    const observer = new MutationObserver(merge);
    observer.observe(document.head, { childList: true });
    merge();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(target)) observer.disconnect();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
